import { useEffect, useState } from "react";

export default function NotionPage() {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("https://us-central1-oing-portfolio.cloudfunctions.net/getNotionData")
      .then((res) => res.json())
      .then((data) => {
        setPages(data.results || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error("❌ 에러 발생:", err);
        setLoading(false);
      });
  }, []);

  return (
    <div className="p-4">
      <h1 className="text-xl font-bold mb-4">📄 Notion 데이터</h1>
      {loading ? (
        <p>로딩 중...</p>
      ) : pages.length === 0 ? (
        <p>데이터가 없습니다.</p>
      ) : (
        <ul className="space-y-4">
          {pages.map((page) => {
            const nameText =
              page.properties?.name?.title?.[0]?.plain_text || "(이름 없음)";
            const titleText =
              page.properties?.title?.rich_text?.[0]?.plain_text ||
              "(타이틀 없음)";
            return (
              <li key={page.id} className="p-4 border rounded-md shadow">
                <p>
                  <strong>이름:</strong> {nameText}
                </p>
                <p>
                  <strong>타이틀:</strong> {titleText}
                </p>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
